export default "__VITE_ASSET__3FkdmqwI__"